/* eslint-disable prefer-arrow/prefer-arrow-functions */
import {
  TotpMultiFactorGenerator,
  TotpSecret,
  User,
  multiFactor,
} from 'firebase/auth';
import { QRCodeSVG } from 'qrcode.react';
import React from 'react';
import {
  closeTopLevelPopup,
  openTopLevelPopup,
} from '../../../data/providers/popupsProvider';
import { ReauthenticatePopup } from './ReauthenticatePopup';

export const QRCode = (props: {
  onTotpSecretChange: (secret: TotpSecret) => void;
  user: User;
}): React.ReactElement => {
  const [url, setUrl] = React.useState<string>('');
  const totpSecret = React.useRef<TotpSecret>(null);
  const getUrl = React.useCallback(async (): Promise<void> => {
    const multiFactorSession = await multiFactor(props.user).getSession();

    try {
      totpSecret.current = await TotpMultiFactorGenerator.generateSecret(
        multiFactorSession
      );
      props.onTotpSecretChange(totpSecret.current);

      setUrl(
        totpSecret.current.generateQrCodeUrl(props.user.email, 'Hawkin Capture')
      );
    } catch (e) {
      if (e.code === 'auth/requires-recent-login') {
        openTopLevelPopup(
          <ReauthenticatePopup
            user={props.user}
            onCancel={closeTopLevelPopup}
          />
        );
        return;
      }
    }
  }, []);

  React.useEffect((): void => {
    getUrl();
  }, [getUrl]);

  return (
    <React.Fragment>
      {url.length > 0 ? (
        <React.Fragment>
          <QRCodeSVG value={url} />
        </React.Fragment>
      ) : null}
    </React.Fragment>
  );
};
